import React from "react";
import { MapPin, Calendar, Award } from "lucide-react";
import { personalInfo, aboutSummary, aboutStats, education } from "../data/mock";

const About = () => {
  return (
    <section id="about" className="relative py-24 sm:py-32">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-blue-400 text-sm font-medium font-mono tracking-wide mb-3">
            01 — About
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
            About Me
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left: Summary */}
          <div className="lg:col-span-3 space-y-6">
            <p className="text-zinc-400 text-base sm:text-lg leading-relaxed">
              {aboutSummary}
            </p>

            {/* Info chips */}
            <div className="flex flex-wrap gap-3 pt-2">
              <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-white/[0.03] border border-white/5">
                <MapPin size={14} className="text-blue-400" />
                <span className="text-sm text-zinc-400">
                  {personalInfo.location}
                </span>
              </div>
              <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-white/[0.03] border border-white/5">
                <Calendar size={14} className="text-blue-400" />
                <span className="text-sm text-zinc-400">
                  Available for opportunities
                </span>
              </div>
            </div>

            {/* Education */}
            <div className="pt-6">
              <h3 className="text-sm font-semibold text-zinc-500 uppercase tracking-wider mb-4">
                Education
              </h3>
              <div className="space-y-3">
                {education.map((edu) => (
                  <div
                    key={edu.id}
                    className="flex items-start gap-3 group"
                  >
                    <Award
                      size={16}
                      className="text-zinc-600 mt-0.5 group-hover:text-blue-400 transition-colors duration-200"
                    />
                    <div>
                      <p className="text-sm font-medium text-zinc-300">
                        {edu.degree}
                      </p>
                      <p className="text-sm text-zinc-500">
                        {edu.institution}
                        <span className="text-zinc-600 mx-1.5">·</span>
                        {edu.period}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Stats */}
          <div className="lg:col-span-2">
            <div className="grid gap-4">
              {aboutStats.map((stat, index) => (
                <div
                  key={stat.label}
                  className="group relative p-6 rounded-xl bg-white/[0.02] border border-white/5 hover:border-blue-500/20 transition-all duration-300 hover:bg-blue-500/[0.03]"
                >
                  <div className="absolute top-4 right-4 text-[10px] font-mono text-zinc-700">
                    0{index + 1}
                  </div>
                  <p className="text-4xl font-bold text-white mb-1 tracking-tight">
                    {stat.value}
                  </p>
                  <p className="text-sm font-medium text-zinc-500">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
